import type React from 'react';

import { Button } from '@change/ds-core-ui';

type PageSkipButtonProps = {
	skipUrl: string;
	skipLabel: string;
	onSkipClick: () => void;
};

export const PageSkipButton: React.FC<PageSkipButtonProps> = ({ skipUrl, skipLabel, onSkipClick }) => (
	<Button
		as="a"
		href={skipUrl}
		onClick={onSkipClick}
		data-qa="skip-link"
		variant="tertiary"
		size="large"
		className="self-center"
	>
		{skipLabel}
	</Button>
);
